import { render, staticRenderFns } from "./GestionHidrocarburos.vue?vue&type=template&id=7c97b17f"
import script from "./GestionHidrocarburos.vue?vue&type=script&lang=js"
export * from "./GestionHidrocarburos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports